class AuditLog extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = `<span style="font-size:16px"><a class="audit-detail fa-history ga-tooltip" data-toggle="tooltip" data-placement="left" title="Show History"></a></span>
                      <div class="modal fade bd-example-modal-sm" id="AuditModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title">History</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <table class="table audit_table" style="width:100%">
                                  <thead>
                                    <th>User</th>
                                    <th>Date</th>
                                    <th>Description</th>
                                  </thead>
                                  <tbody>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>`


    this.init();
  }

  async init() {
    this.table = $(this.querySelector('.audit_table')).DataTable({
      "ajax": this.getAttribute("href"), // Use attribute href from element.
      "columns": [
        {
          "data": "user_id"
        },
        {
          "data": "created_at",
        },
        {
          data: "audited_changes",
          "render": function ( data, type, row ) {
            return data.change
          },
        }
      ],
      order: [[ 1, "desc" ]]
    });

    // Affects the position of the changes link. Could be inconsistent in future use.
    // this.querySelector(".audit-detail").closest("div").getAttribute("class") == "col-sm-6" ? this.querySelector(".audit-detail").classList.remove("pull-right") : this.querySelector(".audit-detail").classList.add("pull-right")

    this.querySelector(".audit-detail").addEventListener("click", function() {
      $(this.querySelector(".modal")).modal("show");
    }.bind(this));

    let res = await fetch(this.getAttribute("href"));
    let changeNum = await res.json();
    this.querySelector(".audit-detail").innerHTML = `&nbsp(${changeNum.data.length})`
  }
}

customElements.define("audit-log", AuditLog)
